import { render, staticRenderFns } from "./Remember.vue?vue&type=template&id=2cbcdba3&scoped=true&"
import script from "./Remember.vue?vue&type=script&lang=js&"
export * from "./Remember.vue?vue&type=script&lang=js&"
import style0 from "./Remember.vue?vue&type=style&index=0&id=2cbcdba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbcdba3",
  null
  
)

component.options.__file = "Remember.vue"
export default component.exports